import { ActionReducerMap } from '@ngrx/store';

import { PnrWidgetState } from '../../interfaces';
import { upcomingTripsReducer } from './upcoming-trips.reducer';

export const reducers: ActionReducerMap<PnrWidgetState> = {
  tripsMmb: upcomingTripsReducer,
};
